import { createContext, useContext, type ReactNode } from 'react';

/** Scope for WpHeader / save inject to resolve signoff store key. */
export type WpSignoffScope = {
  companyId: number | null;
  annualId: number | null;
  code: string | null;
  yearOfAssessment: string | null;
  /** When true, header is display-only (e.g. Total view). */
  readOnly?: boolean;
};

const WpSignoffScopeContext = createContext<WpSignoffScope | null>(null);

export function WpSignoffScopeProvider({
  value,
  children,
}: {
  value: WpSignoffScope;
  children: ReactNode;
}) {
  return (
    <WpSignoffScopeContext.Provider value={value}>
      {children}
    </WpSignoffScopeContext.Provider>
  );
}

export function useWpSignoffScope(): WpSignoffScope | null {
  return useContext(WpSignoffScopeContext);
}
